import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=1bf4a5a4&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4a5a4",
  null
  
)

export default component.exports